import React from 'react';
import { NavLink } from 'react-router-dom';
import {
    LogOut, X, ShieldAlert, Megaphone, CreditCard, WalletCards, RotateCcw,
    Truck, KeyRound, ShieldCheck, FileText, Store, Users, ShoppingBag, BarChart3,
} from 'lucide-react';
import { PAYMENT_MESSAGES } from '@/features/orders/paymentCopy';

const NAV_ITEMS = [
    { label: 'پروفایل من', path: '/super-admin/profile', icon: KeyRound },
    { label: 'مدیریت ادمین‌ها', path: '/super-admin/admins', icon: ShieldAlert },
    { label: 'مدیریت فروشندگان', path: '/super-admin/vendors', icon: Store },
    { label: 'مدیریت کاربران', path: '/super-admin/users', icon: Users },
    { label: 'مدیریت سفارشات', path: '/super-admin/orders', icon: ShoppingBag },
    { label: 'پرداخت‌ها', path: '/super-admin/payments', icon: CreditCard },
    { label: 'تسویه با فروشندگان', path: '/super-admin/settlements', icon: WalletCards, end: true },
    { label: 'تاریخچه پرداخت‌ها', path: '/super-admin/settlements/payouts', icon: CreditCard },
    { label: 'بازگشت وجه', path: '/super-admin/settlements/refunds', icon: RotateCcw },
    { label: 'هزینه ارسال', path: '/super-admin/settlements/shipping', icon: Truck },
    { label: PAYMENT_MESSAGES.sellerGatewayNav, path: '/super-admin/settlements/seller-gateways', icon: ShieldCheck },
    { label: PAYMENT_MESSAGES.auditNav, path: '/super-admin/settlements/audit', icon: FileText },
    { label: 'قراردادهای سازمانی', path: '/super-admin/contracts', icon: FileText },
    { label: 'گزارش‌ها', path: '/super-admin/reports', icon: BarChart3 },
    { label: 'پیام‌های گروهی', path: '/super-admin/announcements', icon: Megaphone },
];

export default function SuperAdminSidebar({ isOpen, onClose, onLogout }) {
    return (
        <>
            {isOpen && <div className="admin-sidebar-backdrop" onClick={onClose} />}

            <aside className={`admin-sidebar glass-sidebar ${isOpen ? 'open' : ''}`}>
                <div>
                    {/* هدر سایدبار بدون عنوان */}
                    <div className="admin-sidebar-header">
                        <button onClick={onClose} className="admin-sidebar-close hidden-mobile" aria-label="بستن منو">
                            <X size={18} />
                        </button>
                    </div>

                    <nav className="admin-nav">
                        {NAV_ITEMS.map((item) => {
                            const Icon = item.icon;
                            return (
                                <NavLink
                                    key={item.path}
                                    to={item.path}
                                    end={item.end}
                                    onClick={onClose}
                                    className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
                                    title={item.label}
                                >
                                    <Icon size={20} className="nav-icon" />
                                    <span>{item.label}</span>
                                </NavLink>
                            );
                        })}
                    </nav>
                </div>

                <div className="admin-sidebar-footer">
                    <button onClick={onLogout} className="admin-logout-btn" title="خروج از حساب">
                        <LogOut size={20} className="nav-icon" />
                        <span>خروج از حساب</span>
                    </button>
                </div>
            </aside>
        </>
    );
}